import autoKraftersIncGenericDefaults from '../ztqdbmzzjj-1/config.js';

export default {
  ...autoKraftersIncGenericDefaults,
  includes: ['bigcommerce-generic', 'ztqdbmzzjj-1'],
};
